<template>
  <div class="articles">
    <h1 class="title">{{ category.title }}</h1>
    <div>
      <ul class="list articles-list">
        <li v-for="article in paginatedOrders" :key="article.name">
          <button
            class="article-button"
            :class="{
              'article-button--active': openArticleIds.includes(article.id.toString())
            }"
          >
            <a
              :data-article="article.id"
              @click.prevent="showArticle"
              style="color: inherit; text-decoration: inherit;"
              v-bind:href="`#${article.source_id}-${article.title.replace(/ /g, '-')}`"
              >{{ article.title }}</a
            >
          </button>
          <div :id="`art-${article.id}`" class="article-body article-body-zeus">
            <div v-html="article.body" data-external="articles"></div>
          </div>
        </li>
      </ul>
      <div class="container-button">
        <button @click="loadMore" v-if="currentPage * maxPerPage < articles.length" class="button__show-more btn">
          Show more
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getStorage, replaceMaHcLoginSupportContent } from '@/utils/common';
export default {
  props: {
    name
  },
  data() {
    return {
      openArticleIds: [],
      currentPage: 1,
      maxPerPage: 20
    };
  },
  updated() {
    replaceMaHcLoginSupportContent();
  },
  methods: {
    handleArticleClick(id) {
      if (this.openArticleIds.includes(id)) {
        let index = this.openArticleIds.indexOf(id);

        this.openArticleIds.splice(index, 1);
      } else {
        this.openArticleIds.push(id);
      }
    },
    showArticle(e) {
      let articleId = e.target.dataset.article;
      let element = document.querySelector(`#art-${articleId}`);
      if (this.openArticleIds.includes(articleId)) {
        element.style['max-height'] = `0px`;
        element.classList.remove('active');
        this.handleArticleClick(articleId);
        return;
      }
      element.style['max-height'] = `${element.scrollHeight}px`;
      element.style['transition'] = '0.5s';
      this.handleArticleClick(articleId);
      element.classList.add('active');
      this.activeArticle = articleId;
    },
    loadMore() {
      this.currentPage += 1;
    }
  },
  computed: {
    pageTitle() {
      const pageTitle = this.name;
      return pageTitle;
    },
    category() {
      const name = this.$store.state.categories[this.$route.meta.categoryId];
      return name;
    },
    articles() {
      const articlesArray = this.$store.state.articles[this.$route.meta.categoryId] || [];
      return articlesArray;
    },
    paginatedOrders() {
      return this.articles.slice(0, this.currentPage * this.maxPerPage);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/zeus-design.scss';
.articles {
  .title {
    margin: 0 0 30px;
    font-size: 24px;
    font-family: Segoe UI, Arial, sans-serif;
    font-weight: 400;
    color: #444;
  }
}

.articles-list {
  margin: 0;
  padding: 0;
  list-style: none;
  li {
    margin: 0 0 20px;
  }
}

.article-button {
  color: #287EFF;
  -webkit-appearance: none;
  background: transparent;
  border: 0;
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  font-family: Segoe UI, Arial, sans-serif;
  cursor: pointer;
  transition: 0.1s linear color;
  padding: 0;
  margin: 0;
  width: 100%;
  line-height: 1.5;
  &:hover {
    color: #333333;
  }
  &:focus {
    color: #333333;
  }
  &.article-button--active,
  &.active {
    color: #333333;
  }
}
.article-body {
  transition: 1s;
  overflow: hidden;
  font-size: 14px;
  font-family: Segoe UI, Arial, sans-serif;
  font-weight: 300;
  max-height: 0;
  > div {
    padding: 20px 0 0;
  }
  p {
    margin: 0;
  }

  a {
    color: #287EFF;
    text-decoration: none;
  }
}

@media (max-width: 768px) {
  .article-body {
    > div {
      padding: 0;
    }
  }
}
</style>
